// ── SettingsClaudePanel (Evo Brain) ──────────────────────────────────────────
// No renderiza UI propia — el shell vive en AssistantDock. Mismo patrón que
// HomeClaudePanel: sin entidad propia. entityType 'settings' ya estaba
// mapeado a module 'global' (ver ENTITY_TO_MODULE en service.ts) — nadie lo
// registraba todavía, así que el dock quedaba con lo último activo.
import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';

export function SettingsClaudePanel() {
  const { t } = useTranslation();

  useAssistantModule('settings', null, undefined);
  useRegisterAssistantActive('settings', null, {
    title: t('settings.assistant.title'),
    placeholder: t('settings.assistant.placeholder'),
    emptyHint: t('settings.assistant.empty'),
  });

  return null;
}
